module.exports = __webpack_public_path__ + "img/salespersonRegister.43ddb886.png";